
import { Menu } from 'lucide-react'
import { useLocation } from "react-router-dom"
import { Sheet, SheetContent, SheetTrigger } from '../ui/sheet'

export function MobileMenu() {
  const location = useLocation()
  
  const isActive = (path: string) => location.pathname === path

  return (
    <Sheet>
      <SheetTrigger className="lg:hidden">
        <Menu className="h-6 w-6" />
      </SheetTrigger>
      <SheetContent side="left" className="w-full bg-[#ffffff] font-['Cormorant_Infant'] mt-16">
        <nav className="flex flex-col gap-8">
          <a
            href="/gallery"
            className={`text-[16px] font-[600] ${
              isActive("/gallery") ? "text-[#B87775]" : ""
            }`}
          >
            GALLERY
          </a>
          <a
            href="/booking"
            className={`text-[16px] font-[600] ${
              isActive("/booking") ? "text-[#B87775]" : ""
            }`}
          >
            BOOK A SESSION
          </a>
          {/* <a
            href="/shop"
            className={`text-[16px] font-[600] ${
              isActive("/shop") ? "text-[#B87775]" : ""
            }`}
          >
            SHOP
          </a> */}
          <a
            href="/reviews"
            className={`text-[16px] font-[600] ${
              isActive("/reviews") ? "text-[#B87775]" : ""
            }`}
          >
            REVIEWS
          </a>
          <a
            href="/our-story"
            className={`text-[16px] font-[600] ${
              isActive("/our-story") ? "text-[#B87775]" : ""
            }`}
          >
            OUR STORY
          </a>
          <a
            href="/privacy-policy"
            className={`uppercase text-[16px] font-[600] ${
              isActive("/privacy-policy") ? "text-[#B87775]" : ""
            }`}
          >
            Privacy Policy
          </a>
        </nav>
      </SheetContent>
    </Sheet>
  )
}

